import { render } from "./HoursEditor.vue?vue&type=template&id=4f5b9402&scoped=true"
import script from "./HoursEditor.vue?vue&type=script&lang=js"
export * from "./HoursEditor.vue?vue&type=script&lang=js"

import "./HoursEditor.vue?vue&type=style&index=0&id=4f5b9402&scoped=true&lang=scss"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f5b9402"]])

export default __exports__